import axios from 'axios';
import {useEffect} from 'react';
import {BACKEND_URL} from 'config';

const useAxiosInterceptor = () => {
  useEffect(() => {
    axios.interceptors.request.use(async request => {
      const baseURL = BACKEND_URL;
      return {
        ...request,
        baseURL,
        validateStatus: (_status: number) => true,
      };
    });
    axios.interceptors.response.use(async response => {
      return response;
    });
  }, []);
};

export default useAxiosInterceptor;
